module.exports = __webpack_public_path__ + "static/bi-slider1-b881f97b0488323f4dd0bd59d5899da1.jpeg";